import React from "react";
import {Columns, Heading, Table} from "react-bulma-components";
import LoadingSpinner from "../Utils/Spinner";


export default function WorkshopFigures({workData, workLoaded, partsData, partLoaded, profit}){

    const colour = () => {
        if(profit > 0){
            return "table-highlight-green-black-text"
        }
        else if(profit < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }

    if(!workLoaded || ! partLoaded){
        return <LoadingSpinner/>
    }

    return (
        <div>
            <Heading>Workshop</Heading>
            <Columns>
                <Columns.Column>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Total Work Labour Cost</th>
                                <th>Total Work Labour Customer Charge</th>
                                <th>Total Part Cost</th>
                                <th>Total Part Customer Charge</th>
                                <th>Profit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{workData.total_cost}</td>
                                <td>{workData.total_customer_cost}</td>
                                <td>{partsData.total_cost}</td>
                                <td>{partsData.total_customer_charge}</td>
                                <td className={colour()}>{profit}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    )



}